import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

/** Payment bank for THIS invoice — the only account a payment reminder shows. Staff only; no financial values change. */
export function PaymentBankPanel({ invoiceId }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/invoice-centre/${invoiceId}/payment-bank`).then((r) => setD(r.data)).catch(() => setD(false)); }, [invoiceId]);
  if (!d) return null;
  const save = async (value) => {
    setBusy(true);
    try {
      const body = value === "__quote" ? { inherit_from_quote: true } : { bank_account_id: value || null };
      const r = await api.put(`/invoice-centre/${invoiceId}/payment-bank`, body);
      setD(r.data); toast.success("Payment bank saved");
    } catch (e) { toast.error(e.response?.data?.detail || "Could not save"); } finally { setBusy(false); }
  };
  const value = d.selected || (d.inherit_from_quote ? "__quote" : "");
  return (
    <div className="border rounded p-3 text-[12px]" data-testid="inv-payment-bank">
      <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-1">Payment bank (shown in payment reminders)</div>
      <select value={value} disabled={busy} onChange={(e) => save(e.target.value)} className="h-8 border rounded px-2 text-[12px] w-full" data-testid="inv-payment-bank-select">
        <option value="">— Not selected —</option>
        {(d.options || []).map((o) => <option key={o.id} value={o.id}>{[o.bank || o.label, o.last4 ? `••${o.last4}` : null].filter(Boolean).join(" · ")}</option>)}
        <option value="__quote">Use the quotation's frozen bank</option>
      </select>
      {d.mode === "PAIR" ? (
        <div className={"mt-1 " + (d.status.ok ? "text-emerald-700" : "text-rose-700")} data-testid="inv-payment-bank-pair">
          {d.status.ok
            ? <>Reminders show {d.issuer}'s approved remittance pair: {d.card.accounts.map((a) => `${a.bank} ••${a.account_no.slice(-4)}`).join(" + ")}.
                {" "}{d.selected ? (d.status.invoice_selected_in_pair ? "This invoice's selected bank is one of the pair." : "This invoice's selected bank is NOT in the pair — the reminder still shows the pair; the invoice selection is unchanged.") : "No bank selected on this invoice (record only)."}</>
            : d.status.warning}
        </div>
      ) : d.status.ok
        ? <div className="mt-1 text-emerald-700" data-testid="inv-payment-bank-ok">{d.card.accounts[0].bank} · {d.card.accounts[0].account_no} · {d.card.accounts[0].ifsc} ({d.status.source === "QUOTATION_FROZEN" ? "from quotation" : "selected on invoice"})</div>
        : <div className="mt-1 text-rose-700" data-testid="inv-payment-bank-issue">{d.status.warning}</div>}
      {d.standard?.state === "APPROVED" && <div className="mt-1 text-emerald-700" data-testid="inv-payment-standard">Approved reminder format ({String(d.standard.approved_at || "").slice(0, 10)}) — AXIS + KOTAK cards with UPI QR below</div>}
      {d.standard?.state === "DIFFERS" && <div className="mt-1 text-amber-700" data-testid="inv-payment-standard">Payment setup differs from the approved reminder format — check Bank Master</div>}
      {d.status.ok && (d.qr_setup || []).map((q) => (
        (q.notice || q.state === "ACTIVE") && <div key={q.key || q.bank_account_id || q.bank} className={"mt-1 " + (q.notice ? "text-amber-700" : "text-emerald-700")} data-testid={`inv-payment-qr-${q.key || q.bank_account_id || "frozen"}`}>
          {q.notice ? `${q.bank}: ${q.notice}` : `${q.bank}: UPI QR included (${q.vpa})`}
        </div>))}
      {d.mode === "PAIR" && d.invoice_selection && !d.invoice_selection.ok && <div className="mt-1 text-amber-700" data-testid="inv-payment-bank-selection-issue">{d.invoice_selection.warning}</div>}
    </div>
  );
}
